module.exports = __webpack_public_path__ + "img/sponsorO30.a6a8d6f3.png";